import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

export const StyledMenu = styled.div`
  z-index: 15;
  background-color: #010e33;
  display: flex;
  flex-direction: row;
  align-items: center;
  /* margin: -2px 0; */
  /* height: 70px; */
`;

export const Logo = styled.img.attrs({
  src: "/assets/imgs/Logov1.png",
})`
  padding: 1.5rem 0;
  height: 8rem;
`;

export const MenuItem = styled(Link)`
  font-size: 1.7rem;
  font-weight: bolder;
  height: 100%;
  color: white;
  display: block;
  padding: 0 3rem;
  &:hover {
    color: ${(props) => props.theme.secondary};
  }
`;

export const Container = styled.nav`
  background-color: ${(props) => props.theme.secondary};
  width: 100%;
  height: 100px;
`;

export const MenuContainer = styled.div`
  position: absolute;
  top: ${(props) => props.offset}px;
  left: 0%;
  width: 100%;
  height: calc(100% - ${(props) => props.offset}px);
  display: flex;
  flex-direction: column;
  z-index: 5;
  background-color: #081845;
  transform: translateY(-100%);
  transition: transform 0.4s ease-in-out;
  pointer-events: none;
  ${(props) =>
    props.active &&
    css`
      opacity: 1;
      transform: translateY(0%);
      pointer-events: all;
    `}
`;

export const Anchor = styled(Link)`
  width: 100%;
  font-size: 2rem;
  text-align: center;
  padding: 5rem 0;
  color: white;
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  &:hover {
    color: ${(props) => props.theme.secondary};
  }
  &:last-of-type {
    border-bottom: none;
  }
  ${(props) =>
    props.active &&
    css`
      background-color: ${props.theme.secondary};
      color: white;
    `}
`;

export const MenuRightSection = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: auto;
  height: 100%;
`;

export const HButton = styled.img.attrs((props) => ({
  src: props.active
    ? "assets/icons/closeBurguer.svg"
    : "/assets/icons/menu.svg",
}))`
  margin-left: auto;
  /* height: 100%; */
  width: 5rem;
  padding: 0.5rem;
  margin-right: 2rem;
  cursor: pointer;
`;
